const actionTypeIdentifier = '5D91A4PQ-MX5N-3364-M29F-49D7F3AD9NX4';
//PowerPoint
export const exportPowerPointSuccess =`EXPORT-POWER-POINT-SUCCESS-${actionTypeIdentifier}`;
export const exportPowerPointFailure = `EXPORT-POWER-POINT-FAILURE-${actionTypeIdentifier}`;
export const exportToPowerPointStart = `EXPORT-POWER-POINT-START-${actionTypeIdentifier}`;

//PDF
export const exportPdfSuccess = `EXPORT-PDF-SUCCESS-${actionTypeIdentifier}`;
export const exportPdfFailure = `EXPORT-PDF-FAILURE-${actionTypeIdentifier}`;




